export function removeFieldAtIndex<T>(array: T[], index: number): T[] {
  return [...array.slice(0, index), ...array.slice(index + 1)];
}

export function updateFieldAtIndex<T>(array: T[], newField: T, index: number): T[] {
  return [...array.slice(0, index), newField, ...array.slice(index + 1)];
}

export default { removeFieldAtIndex, updateFieldAtIndex };
